const HorizonalScroll = (el: HTMLElement) => {
  let touchStartLeft = 0;
  let pageX = 0;

  el.style.left = '0px';

  const deltaHandler = (delta: number, lastLeft) => {
    const left = Math.max(0, Math.min(lastLeft - delta, el.clientWidth - el.parentElement.clientWidth));
    el.style.left = `${left}px`;
  };

  const touchStartHandler = (event: TouchEvent) => {
    pageX = event.touches[0].pageX;
    touchStartLeft = parseInt(el.style.left);
  };

  const touchMoveHandler = (event: TouchEvent) => {
    deltaHandler(pageX - event.touches[0].pageX, touchStartLeft);
  };

  const wheelHandler = (event: WheelEvent) => {
    deltaHandler(-event.deltaY, parseInt(el.style.left));
    event.preventDefault();
  };

  el.addEventListener('touchstart', touchStartHandler, {passive: false});
  el.addEventListener('touchmove', touchMoveHandler, {passive: false});
  el.addEventListener('wheel', wheelHandler, {passive: false});

  // Reset event
  return () => {
    el.style.left = '0px';
  };
};

export default HorizonalScroll;
